import { h } from 'preact';
import { useState } from 'preact/compat';
import Logo from '../icons/Logo';

export const Fallback = () => (
	<div className="ea-image-placeholder">
		<span>
			<Logo />
		</span>
	</div>
);

const Image = ({
	src,
	width,
	height,
	alt = '',
	srcset = '',
	sizes = '',
	className = '',
	loading = 'lazy',
}: {
	src: string,
	width: number,
	height: number,
	alt?: string,
	srcset?: string,
	sizes?: string,
	className?: string,
	loading?: 'lazy' | 'eager',
}) => {
	const [loaded, setLoaded] = useState(false);
	const [errored, setErrored] = useState(false);
	return (
		<span
			className={[
				'ea-image',
				className,
				loaded ? 'loaded' : '',
				errored ? 'errored' : '',
				!errored && !loaded ? 'loading' : '',
			].join(' ')}
		>
			<img
				loading={loading}
				alt={alt}
				src={src}
				sizes={sizes}
				srcSet={srcset}
				width={width}
				height={height}
				onLoad={() => {
					setLoaded(true);
				}}
				onError={() => {
					setErrored(true);
				}}
			/>
		</span>
	);
};

export default Image;
